import Icon from '../components/Icon.vue'

Icon.register({"dice-six":{"width":448,"height":512,"paths":[{"d":"M384 0H64C28.6 0 0 28.6 0 64V384C0 419.4 28.6 448 64 448H384C419.4 448 448 419.4 448 384V64C448 28.6 419.4 0 384 0zM128 352C110.3 352 96 337.7 96 320S110.3 288 128 288 160 302.3 160 320 145.7 352 128 352zM128 256C110.3 256 96 241.7 96 224S110.3 192 128 192 160 206.3 160 224 145.7 256 128 256zM128 160C110.3 160 96 145.7 96 128S110.3 96 128 96 160 110.3 160 128 145.7 160 128 160zM320 352C302.3 352 288 337.7 288 320S302.3 288 320 288 352 302.3 352 320 337.7 352 320 352zM320 256C302.3 256 288 241.7 288 224S302.3 192 320 192 352 206.3 352 224 337.7 256 320 256zM320 160C302.3 160 288 145.7 288 128S302.3 96 320 96 352 110.3 352 128 337.7 160 320 160z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/dice-six.js
// module id = vOoN
// module chunks = 0